// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"211e177e","331":"21e7ca65","589":"f629c242"}[chunkId] + ".chunk.js";
};